import { render, staticRenderFns } from "./PublicPageMenuLinkEntry.vue?vue&type=template&id=0b78225a"
import script from "./PublicPageMenuLinkEntry.vue?vue&type=script&setup=true&lang=ts"
export * from "./PublicPageMenuLinkEntry.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports